import React, {Component, lazy, Suspense} from 'react';
import './App.css';
import { HashRouter, Switch, Route } from 'react-router-dom';

// interfaces
import { IAppState } from "./interfaces/IAppState";

// components
import PulseLoader from "react-spinners/PulseLoader";
import {ErrorPage} from "./components/ErrorPage/ErrorPage";
import {Header} from "./components/Header/Header";
import {Footer} from "./components/Footer/Footer";
import {Main} from "./components/Main/Main";
import {ScrollToUpButton} from "./components/ScrollToUpButton/ScrollToUpButton";

// lazy imports
const Announcements = lazy(() =>
    import("./components/Announcements/Announcements")
        .then(({ Announcements }) => ({ default: Announcements })));
const Administration = lazy(() =>
    import("./components/Administration/Administration")
        .then(({ Administration }) => ({ default: Administration })));
const Employees = lazy(() =>
    import("./components/Employees/Employees")
        .then(({ Employees }) => ({ default: Employees })));
const Contacts = lazy(() =>
    import("./components/Contacts/Contacts")
        .then(({ Contacts }) => ({ default: Contacts })));
const Departments = lazy(() =>
    import("./components/Departments/Departments")
        .then(({ Departments }) => ({ default: Departments })));
const PublicInfo = lazy(() =>
    import("./components/PublicInfo/PublicInfo")
        .then(({ PublicInfo }) => ({ default: PublicInfo })));
const Articles = lazy(() =>
    import("./components/Articles/Articles")
        .then(({ Articles }) => ({ default: Articles })));
const Commands = lazy(() =>
    import("./components/Commands/Commands")
        .then(({ Commands }) => ({ default: Commands })));
const OnlineReception = lazy(() =>
    import("./components/OnlineReception/OnlineReception")
        .then(({ OnlineReception }) => ({ default: OnlineReception })));
// ******

export default class App extends Component<any, IAppState> {
    constructor(props: any){
        super(props);

        this.state = {
            titles: {
                title: "Комунальне некомерційне підприємство",
                subtitle: `"Третій Черкаський міський центр первинної медико-санітарної допомоги"`
            },
            date: {
                day: '',
                month: '',
                year: 0
            },
            declarationsData: {
                declarations: [
                    [
                        1819, // Гаврілов
                        1801, // Заїка
                        1349, // Кириченко
                        1826, // Липовець
                        1909, // Орел
                        1941, // Осинська
                        1843, // Старосельска
                        1830  // Старосельський
                    ],
                    [
                        1385, // Дмитрук
                        1775, // Дьомкіна
                        1839, // Костріцька
                        264,  // Криклива
                        1719, // Литвин
                        1892, // Матвійчук
                        1855, // Третяк
                        1711  // Чуприна
                    ],
                    [
                        1939, // Білоус
                        709,  // Горбик
                        1764, // Кочубей
                        1822, // Ларіонова
                        1795, // Литвиненко
                        1845, // Орлова
                        1472, // Осипенко
                        1811, // Очеретнюк
                        1931  // Севастьянова
                    ]
                ],
                calculations: {
                    firstDepSum: 0,
                    secondDepSum: 0,
                    thirdDepSum: 0,
                    genSum: 0
                }
            }
        };
    }

    /**
     *  Gets actual date (day, month, year)
     *  @return number[]
     */

    private getActualDate = (): number[] => {
        const newDate: Date = new Date();

        return [newDate.getDate(), newDate.getMonth()+1, newDate.getFullYear()];
    };

    /**
     * Calculates declarations quantity
     * Passes calculations and date to state
     */
    private getAllData = (): void => {
        let sum1: number = 0,
            sum2: number = 0,
            sum3: number = 0;

        this.state.declarationsData.declarations.forEach((department: number[], id: number) => {
            if (!!department.length) {
                department.forEach((el: number) => {
                    switch (id) {
                        case 0:
                            sum1 += el;
                            break;
                        case 1:
                            sum2 += el;
                            break;
                        case 2:
                            sum3 += el;
                            break;
                        default:
                            break;
                    }
                });
            }
        });

        const date: number[] = this.getActualDate();

        this.setState({
            ...this.state,
            date: {
                day: date[0] > 9 ?
                    '' + date[0] :
                    '0' + date[0],
                month: date[1] > 9 ?
                    '' + +date[1] :
                    '0' + +date[1],
                year: date[2]
            },
            declarationsData: {
                ...this.state.declarationsData,
                calculations: {
                    firstDepSum: sum1,
                    secondDepSum: sum2,
                    thirdDepSum: sum3,
                    genSum: sum1 + sum2 + sum3
                }
            }
        }, () => {});
    };

    componentDidMount() {
        this.getAllData();
    }

    render() {
        return (
            <HashRouter basename={window.location.pathname || ' '} >
                <div className="App">
                    <Header date={this.state.date} />
                    <ScrollToUpButton />
                    <Suspense fallback={
                        <div className="pulseLoader">
                            Loading...
                            <PulseLoader
                                css={`
                                    display: block;
                                    margin: 0 auto;
                                    border-color: red;
                                `}
                                size={ 15 }
                                color={ "#0a090a" }
                                loading={ true }
                            />
                        </div>
                    } >
                        <Switch>
                            <Route exact path="/" render={ () =>
                                <Main date={this.state.date}
                                      declarationsData={this.state.declarationsData} />
                            } />
                            <Route path="/announcements" render={ () => <Announcements />} />
                            <Route path="/administration" render={
                                () => <Administration date={this.state.date} />
                            } />
                            <Route path="/employees" render={
                                () => <Employees date={this.state.date} />
                            } />
                            <Route path="/contacts" render={
                                () => <Contacts titles={this.state.titles} />
                            } />
                            <Route path="/departments" render={
                                () => <Departments />
                            } />
                            <Route path="/public-info" render={
                                () =>
                                    <PublicInfo
                                        date={ this.state.date }
                                        declarationsData={ this.state.declarationsData }
                                    />
                            } />
                            <Route path="/commands" render={
                                () => <Commands />
                            } />
                            <Route path="/articles" render={
                                () => <Articles />
                            } />
                            <Route path="/online-reception" render={
                                () => <OnlineReception />
                            } />
                            <Route component={ErrorPage} />
                        </Switch>
                    </Suspense>
                    <Footer titles={this.state.titles} date={this.state.date} />
                </div>
            </HashRouter>
        );
    }
}
